import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=add3fda2&scoped=true&"
import script from "./Notification.vue?vue&type=script&lang=js&"
export * from "./Notification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add3fda2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('add3fda2')) {
      api.createRecord('add3fda2', component.options)
    } else {
      api.reload('add3fda2', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=add3fda2&scoped=true&", function () {
      api.rerender('add3fda2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/Notification.vue"
export default component.exports